import { z } from "zod";
import {
  SEGMENT_ENTITY_TYPES,
  VIEW_ENTITY_TYPES,
  VIEW_SCOPES,
  filterGroupSchema,
  viewColumnSpecSchema,
  viewSortSchema,
} from "../domain";

// Phase 7 sub-bucket 16 — Saved Views CRUD wire schemas. The legacy
// `viewCreateSchema` / `viewUpdateSchema` already live in `../domain` (and
// are re-exported via @colab/shared) so this file only adds the small
// pieces the new Hono routes need: query-string entity filter, reorder
// payload, and re-exports of the inner block primitives so the SPA
// `FilterTreeBuilder` consumer doesn't have to reach into `domain` directly.
//
// Sub-bucket 18 — switched the entity-type enum to `VIEW_ENTITY_TYPES`
// (superset of SEGMENT_ENTITY_TYPES + admin_deal) so view CRUD accepts
// `'admin_deal'`. Segments stays on SEGMENT_ENTITY_TYPES (no admin_deal
// segments today).

export const viewEntityQuerySchema = z.object({
  entityType: z.enum(VIEW_ENTITY_TYPES),
});
export type ViewEntityQueryInput = z.infer<typeof viewEntityQuerySchema>;

// POST /api/admin/views/reorder body — bulk reorder for one entity_type.
// Ported from /lib/actions/views.ts::reorderViews. Backed by the
// `reorder_views(text, uuid[])` RPC (migration 0025 / 0032).
export const viewReorderBodySchema = z.object({
  entityType: z.enum(VIEW_ENTITY_TYPES),
  orderedIds: z.array(z.string().uuid()).min(1),
});
export type ViewReorderInput = z.infer<typeof viewReorderBodySchema>;

// Re-exports — keeps SPA consumers from importing through `@colab/shared`
// twice for view-shape primitives.
export {
  filterGroupSchema,
  viewColumnSpecSchema,
  viewSortSchema,
  VIEW_SCOPES,
  SEGMENT_ENTITY_TYPES,
  VIEW_ENTITY_TYPES,
};
